import { Component } from "@kluntje/core";
import { fetchJSON } from "Helper/apiHelper";
import { render } from "lit-html";
import { getDocLocale } from "Helper/metaHelper";
import { I18nService } from "Services/I18nService";

import { flightsDetailTemplate } from "./fra-m-flight-detail__list.template"; // eslint-disable-line

class FRAFlightDetail extends Component {
  constructor() {
    super({
      ui: {
        detailList: ".fra-js-flight-detail__details:-one",
      },
      initialStates: {
        flightDetails: [],
      },
      reactions: {
        flightDetails: ["handleDataUpdate"],
      },
    });

    this.updateInterval = null;
  }

  /**
   * Returns provided api-url from custom element
   * @returns {string}
   */
  get apiUrl(): string {
    return this.getAttribute("data-api-url") || "";
  }

  /**
   * Returns provided airline-url from custom element
   * @returns {string}
   */
  get airlineUrl(): string {
    return this.getAttribute("data-airline-url") || "";
  }

  /**
   * Returns provided airline-delay-url from custom element
   * @returns {string}
   */
  get airlineDelayUrl(): string {
    return this.getAttribute("data-airline-delay-url") || "";
  }

  /**
   * Returns provided locale from custom element
   * @returns {string}
   */
  get locale(): string {
    return getDocLocale();
  }

  /**
   * Lifecycle-Hook
   * @override
   */
  afterComponentRender(): void {
    this.fetchFlightDetails();

    this.updateComponent();
  }

  /**
   * Update Component every 2 Minutes
   */
  updateComponent(): void {
    this.updateInterval = setInterval(this.fetchFlightDetails.bind(this), 120000);
  }

  /**
   * Fetch data from API and store response in state
   */
  async fetchFlightDetails(): Promise<void> {
    const apiResponse = await fetchJSON(this.apiUrl);
    this.setState({ flightDetails: apiResponse });
  }

  /**
   * Reaction on state change
   */
  handleDataUpdate(): void {
    this.renderList();
  }

  /**
   * Rendering List with lit
   */
  async renderList(): Promise<void> {
    await I18nService.getInstance().waitForJson();
    const input = flightsDetailTemplate(this.state.flightDetails, this.airlineUrl, this.airlineDelayUrl, this.locale);
    render(input, this.ui.detailList);
  }
}

customElements.define("fra-m-flight-detail", FRAFlightDetail);

export default FRAFlightDetail;
